import { coreUsersByIdSalesforcePreferencesGetAsyncSlice } from './get';
import { CoreUsersByIdSalesforcePreferencesName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { PatchUserSalesforcePreferencesRequest } from '@api';
import { UserSalesforcePreferences } from '@types';

export const coreUsersByIdSalesforcePreferencesUpdateSyncSlice = createUpdateSyncSlice<
	typeof CoreUsersByIdSalesforcePreferencesName,
	UserSalesforcePreferences,
	PatchUserSalesforcePreferencesRequest
>({
	name: CoreUsersByIdSalesforcePreferencesName,
	state: coreUsersByIdSalesforcePreferencesGetAsyncSlice.asyncState
});
